import { CcLibrarySet } from "server/models"
import { OrderType, PublishedUnpublished } from "client/utils"

export interface CcLibrarySetProps {
    setId: number
}

export type CcLibrarySetValidation = { [key in keyof CcLibrarySet]?: string}

export interface CcLibrarySetList { [setId: number]: CcLibrarySet }
export interface CcLibrarySetFilters {
    imported?: boolean
    created?: boolean
    status?: PublishedUnpublished
    search?: string
}
export interface CcLibrarySetImportFilters {
    search?: string
}

export interface CcLibrarySetState {
    baseRoute: string

    setList: CcLibrarySetList
    setIds: readonly number[]
    setView: CcLibrarySet
    setEdit: CcLibrarySet

    sortColumn: keyof CcLibrarySet
    sortOrder: OrderType
    filters: CcLibrarySetFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean

    // import
    importFromLibrary: {
        setList: CcLibrarySetList
        setIds: readonly number[]
        sortColumn: keyof CcLibrarySet
        sortOrder: OrderType
        filters: CcLibrarySetImportFilters
    }

    importFromAccount: {
        setList: CcLibrarySetList
        setIds: readonly number[]
        sortColumn: keyof CcLibrarySet
        sortOrder: OrderType
        filters: CcLibrarySetImportFilters
    }

    importSetId: number
    reloadImported: boolean
}

export const CC_LIBRARY_SET_BASE_ROUTE = "CC_LIBRARY_SET_BASE_ROUTE"

export const CC_LIBRARY_SET_LIST = "CC_LIBRARY_SET_LIST"
export const CC_LIBRARY_SET_IDS = "CC_LIBRARY_SET_IDS"
export const CC_LIBRARY_SET_VIEW = "CC_LIBRARY_SET_VIEW"
export const CC_LIBRARY_SET_EDIT = "CC_LIBRARY_SET_EDIT"

export const CC_LIBRARY_SET_SORT = "CC_LIBRARY_SET_SORT"
export const CC_LIBRARY_SET_FILTERS = "CC_LIBRARY_SET_FILTERS"

export const CC_LIBRARY_SET_RELOAD_LIST = "CC_LIBRARY_SET_RELOAD_LIST"
export const CC_LIBRARY_SET_RELOAD_VIEW = "CC_LIBRARY_SET_RELOAD_VIEW"
export const CC_LIBRARY_SET_RELOAD_EDIT = "CC_LIBRARY_SET_RELOAD_EDIT"


export const CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_LIST = "CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_LIST"
export const CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_IDS = "CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_IDS"
export const CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_SORT = "CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_SORT"
export const CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_FILTERS = "CC_LIBRARY_SET_IMPORT_FROM_LIBRARY_FILTERS"

export const CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_LIST = "CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_LIST"
export const CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_IDS = "CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_IDS"
export const CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_SORT = "CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_SORT"
export const CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_FILTERS = "CC_LIBRARY_SET_IMPORT_FROM_ACCOUNT_FILTERS"

export const CC_LIBRARY_SET_IMPORT_ID = "CC_LIBRARY_SET_IMPORT_ID"
export const CC_LIBRARY_SET_RELOAD_IMPORTED = "CC_LIBRARY_SET_RELOAD_IMPORTED"
